import request from '@/utils/request.js'

/******获取我的核算列表********/
export function getMyAccountingList(data){
    return request({
        url: 'financial/order/mySelf',
        method: 'post',
        data
    })
}
/******获取我的结算列表********/
export function getOrderSettlementList(data){
    return request({
        url: 'financial/order/countList',
        method: 'post',
        data
    })
}
/** 订单核算导出 */
export function exportFinancialInfo(data){
    return request({
        url: 'export/orderFinancialInfo',
        method: 'post',
        data
    })
}
/******订单核算********/
export function orderSettlement(data){
    return request({
        url: 'financial/order/updateState',
        method: 'post',
        data
    })
}

/****** 余额提现列表 ********/
export function getCashOutList(data){
    return request({
        url: 'agent/account/cashout/apply/listPage',
        method: 'post',
        data
    })
}


/****** 余额提现审核列表 ********/
export function getCashOutApproveList(data){
    return request({
        url: 'agent/account/cashout/approve/listPage',
        method: 'post',
        data
    })
}


/****** 申请提现 ********/
export function applyCashOut(data){
    return request({
        url: 'agent/account/cashout/apply',
        method: 'post',
        data
    })
}


/****** 提现审核 ********/
export function cashOutApprove(data){
    return request({
        url: 'agent/account/cashout/approve',
        method: 'post',
        data
    })
}

/****** 提现审核导出 ********/
export function exportAgentCashoutList(data){
    return request({
        url: 'export/sysAgentCashoutList',
        method: 'post',
        data
    })
}


